import H from 'history'
import React, { Fragment } from 'react'

import { AppState } from 'common/store'
import { connect, DispatchProp } from 'react-redux'
import { EntitledToView } from '../entitlements/EntitledToView'
import { BreachEvent } from 'common/events/breachEventTypes'
import {
    InlinePositionedContent,
    TargetedContent,
} from 'component-library/templates/Publication/Publication.props'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { TogglesState } from 'common/feature-togglings/reducer'
import { BreachNotificationWrapper } from './components/BreachNotificationWrapper'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import { StyledArticleBreachNotification } from './ArticleBreach.styled'
import {
    ResponsiveProps,
    responsiveComponent,
} from 'component-library/__helpers/responsive-component'
import { Block } from 'common/client-data-types/blocks'

interface OwnProps {
    isPremium: boolean
    location: H.Location
    blocks: Block[]
    slug: string

    // inlinePositionedContent and targetedContent are for placing ads between content
    inlinePositionedContent?: InlinePositionedContent[]
    targetedContent?: TargetedContent

    onEvent: (event: BreachEvent) => void
    children: (content: {
        blocks: Block[]
        inlinePositionedContent: InlinePositionedContent[] | undefined
        targetedContent: TargetedContent | undefined
    }) => React.ReactElement<any>

    publicationId: string
    publicationHeadline: string
}

export type Props = OwnProps & { toggles: TogglesState } & DispatchProp<any> & ResponsiveProps
const mapStateToProps = (state: AppState) => ({ toggles: state.toggles })

export const InternalArticleBreach: React.FC<Props> = props => {
    const {
        blocks,
        inlinePositionedContent,
        targetedContent,
        isPremium,
        location,
        onEvent,
        slug,
    } = props

    // We currently have a few variants running at the same time. Since the form
    // is an A|B test not related to the breach screen tests we're simply
    // appending the variant to the current creativeName.
    const appendAdditionalVariant = (creativeName: string) =>
        isFeatureEnabled(props.toggles, 'simple-digital-subscription-form')
            ? `${creativeName}_SimpleDigital`
            : creativeName

    const creativeName = appendAdditionalVariant('launch - no content')

    const deal = 'launch deal'

    return (
        <EntitledToView
            isPremium={isPremium}
            articleSlug={slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                creativeName,
                deal,
                location,
                onEvent
            )}
            entitled={() => {
                return props.children({
                    blocks,
                    inlinePositionedContent,
                    targetedContent,
                })
            }}
            notEntitled={() => {
                return (
                    <Fragment>
                        <StyledArticleBreachNotification>
                            <BreachNotificationWrapper
                                breachDeal={deal}
                                articleId={props.publicationId}
                                breachCreativeName={creativeName}
                                onEvent={props.onEvent}
                            />
                        </StyledArticleBreachNotification>
                    </Fragment>
                )
            }}
        />
    )
}

export const ArticleBreach: React.ComponentType<OwnProps> = responsiveComponent<OwnProps>(
    connect<{ toggles: TogglesState }, {}, OwnProps, AppState>(
        mapStateToProps,
        null,
        null,
        {}
    )(InternalArticleBreach)
)

ArticleBreach.displayName = 'ArticleBreach'
